import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export function AuthRecaptchaProvider({ siteKey, children }) {
  if (!siteKey) {
    return children;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      useRecaptchaNet={true}
      scriptProps={{
        async: true,
        defer: true,
      }}
      container={{
        element: "recaptcha-container",
        parameters: {
          badge: "bottomright",
          theme: "light",
        },
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
